export default {
  ESTABLISHMENTS_LIST: "Establishments list",
  ADD_ESTABLISHMENT: "Add establishment",
  ESTABLISHMENT_ADDED: "Establishment added",
  EDIT_ESTABLISHMENT: "Edit establishment",
  ESTABLISHMENT_UPDATED: "Establishment updated",
  DELETE_THIS_ESTABLISHMENT: "Delete this establishment ?",
  ESTABLISHMENT_DELETED: "Establishment deleted",
  BILLING_INFORMATIONS_SAME_AS_ESTABLISHMENT: "Same as establishment",
  ESTABLISHMENT_TYPE_ELEMENTARY: "Elementary",
  ESTABLISHMENT_TYPE_SECONDARY: "Secondary",
  ESTABLISHMENT_TYPE_COLLEGE: "College",
  ESTABLISHMENT_TYPE_UNIVERSITY: "University",
  ACTIVATE: "Activate",
  DESACTIVATE: "Desactivate",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  ESTABLISHMENT_ACTIVATED: "Establishment activated",
  ESTABLISHMENT_DEACTIVATED: "Establishment deactivated",
  ESTABLISHMENT_INACTIVE_ALERT:
    "This establishment is deactivated: adding orders, submission, transfers, internal invoices, weekly reports and cash register readings are unavailable.",
  DEACTIVATE_ESTABLISHMENT_TITLE: "Deactivate establishment",
  DEACTIVATE_ESTABLISHMENT_INTRO:
    "You are about to deactivate the establishment:",
  DEACTIVATE_RECAP_HEADER:
    "Once deactivated, the following actions will be disabled or inaccessible for this establishment:",
  DEACTIVATE_RECAP_ORDERS: "Adding sales and purchases orders",
  DEACTIVATE_RECAP_SUBMISSION: "Submitting (validating) orders",
  DEACTIVATE_RECAP_TRANSFERS: "Creating inter-establishment transfers",
  DEACTIVATE_RECAP_INTERNAL_INVOICES: "Creating internal invoices",
  DEACTIVATE_RECAP_WEEKLY_REPORTS: "Generating weekly reports",
  DEACTIVATE_RECAP_CASH_REGISTERS: "Reading and entering cash registers",
  DEACTIVATE_RECAP_ALL_LINKED:
    "Adding any item linked to the establishment (contacts, cafeterias, cash registers, equipment, customers, warehouse and products, deliveries, invoices, payments, stock movements…)",
  DEACTIVATE_RECAP_FOOTER:
    "You can reactivate the establishment at any time to restore these actions.",
  CONFIRM_DEACTIVATION: "Confirm deactivation",
  PENDING_ITEMS_TITLE: "Pending items for this establishment",
  PENDING_LOADING: "Loading pending items…",
  PENDING_NONE: "No pending items.",
  PENDING_WARNING:
    "These items will remain frozen in their current state while the establishment is deactivated:",
  PENDING_SALES_ORDERS: "Quotes in progress",
  PENDING_PURCHASES_ORDERS: "Purchases orders in progress",
  PENDING_SALES_DELIVERIES: "Sales deliveries (draft)",
  PENDING_PURCHASES_DELIVERIES: "Purchases deliveries (draft)",
  PENDING_SALES_INVOICES: "Unsettled sales invoices",
  PENDING_PURCHASES_INVOICES: "Unsettled purchases invoices",
  PENDING_SALES_PAYMENTS: "Sales payments (draft)",
  PENDING_PURCHASES_PAYMENTS: "Purchases payments (draft)",
  PENDING_STOCK_MOVEMENTS: "Stock movements (draft)",
  PENDING_TRANSFERS: "Pending transfers",
  PENDING_INTERNAL_INVOICES: "Pending internal invoices",
  PENDING_WEEKLY_REPORTS: "Weekly reports (draft)",
  PENDING_CASH_REGISTER_READINGS: "Cash register readings (draft)",
  PENDING_SPECIAL_ORDER_RESERVATIONS: "Special order reservations in progress",
  ESTABLISHMENT_TYPE: "Establishment type",
  TARGET_VALUES: "Target Values",
  TARGET_WAGES: "Target Wages",
  TARGET_CONSUMABLES: "Target Consumables",
  TARGET_PURCHASES: "Target Purchases",
  TARGET_NET_PROFIT: "Target Net Profit",
  WEEKLY_RENT: "Weekly Rent",
  WEEKLY_REPORTS_ENABLED: "Produces weekly reports",
  WEEKLY_REPORTS_ENABLED_HELP:
    "Uncheck for an establishment that does not do weekly reports: it no longer appears in weekly report menus, buttons and dashboard, and no new report can be created. Existing reports remain viewable.",
  WEEKLY_RENT_TYPE: "Weekly Rent Type",
  FIXED_AMOUNT: "Fixed Amount",
  DISCOUNT: "Discount",
  SELECT_RENT_TYPE: "Select rent type",
  ENTER_AMOUNT: "Enter amount",
  BULK_SET_TARGET_VALUES: "Bulk Set Target Values",
  BULK_SET_TARGET_VALUES_DESC: "Set target values for {count} selected establishments",
  BULK_UPDATE_SUCCESS: "Target values updated successfully",
  CONFIGURE_DISCOUNTS: "Configure discounts",
  CONFIGURE_DISCOUNT_RATES: "Configure discount rates",
  CONFIGURE_DISCOUNT_RATES_BULK: "Configure discount rates (bulk)",
  DISCOUNT_BULK_NOT_AVAILABLE: "Per-source discounts cannot be configured in bulk. Set them individually.",
  ISTHERA_PRODUCTS: "Cash register products (ISTHERA)",
  ISTHERA_DATABASE: "ISTHERA database",
  ISTHERA_NOT_MAPPED: "This establishment is not linked to any ISTHERA database.",
  ISTHERA_PROVISION: "Provision to ISTHERA",
  ISTHERA_SIMULATE: "Simulate",
  ISTHERA_PURGE: "Deactivate products not in ERP",
  ISTHERA_PURGE_NONE: "No active non-ERP product to deactivate.",
  ISTHERA_PURGE_CONFIRM:
    "Deactivate {count} cash-register product(s) not in the ERP? They stay in the database (history kept), just inactive.",
  ISTHERA_PURGE_DONE: "{deleted} non-ERP product(s) deactivated.",
  ISTHERA_PROVISION_PURGE_OPTION:
    "Also deactivate cash-register products not in the ERP (make the caisse identical to the ERP)",
  ISTHERA_PURGED: "Deactivated (non-ERP)",
  ISTHERA_SYNC_ONE: "Sync",
  ISTHERA_SYNC_ONE_DONE: "Product synchronized.",
  ISTHERA_STATUS: "Status",
  ISTHERA_ALL_STATUSES: "All statuses",
  ISTHERA_ACTION_CREATE: "To create",
  ISTHERA_ACTION_UPDATE: "To update",
  ISTHERA_ACTION_SYNCED: "Synced",
  ISTHERA_ACTION_DEACTIVATE: "To deactivate",
  ISTHERA_ACTION_LINK: "To attach",
  ISTHERA_ACTION_CONFLICT: "Barcode conflict",
  ISTHERA_IN_CAISSE: "In the caisse: {value}",
  ISTHERA_IN_ERP: "Manager: {value}",
  ISTHERA_DEACTIVATE_DUPLICATE_CONFIRM:
    "Deactivate this cash-register product (same barcode as a manager product)? It stays in the database (history kept), just inactive.",
  ISTHERA_DEACTIVATE_ONE: "Deactivate",
  ISTHERA_DEACTIVATE_ONE_CONFIRM:
    "Deactivate this cash-register product (not in the ERP)? It stays in the database (history kept), just inactive.",
  ISTHERA_DEACTIVATE_ONE_DONE: "Product deactivated.",
  ISTHERA_PROVISION_CONFIRM:
    "Provision all sellable products of this establishment to ISTHERA?",
  ISTHERA_PROVISION_DONE: "Provisioning completed",
  ISTHERA_SIMULATION_DONE: "Simulation completed (no writes)",
  ISTHERA_RESULT:
    "{created} created, {updated} updated, {unchanged} unchanged, {deactivated} deactivated, {errors} error(s)",
  ISTHERA_RUNNING: "Provisioning in progress… {processed}/{total}",
  ISTHERA_FAILED: "Provisioning failed",
  ISTHERA_RESULT_TITLE: "Last provisioning result",
  ISTHERA_RESULT_TITLE_DRY: "Last simulation result",
  ISTHERA_DRY_BADGE: "Simulation: no writes",
  ISTHERA_CREATED: "Created",
  ISTHERA_UPDATED: "Updated",
  ISTHERA_UNCHANGED: "Unchanged",
  ISTHERA_DEACTIVATED: "Deactivated",
  ISTHERA_ERRORS: "Errors",
  ISTHERA_TOTAL: "Total",
  ISTHERA_FINISHED_AT: "Finished at",
  ISTHERA_ERROR_DETAILS: "Error details",
  ISTHERA_ERROR_GLOBAL: "Whole run",
  ISTHERA_CODE_ACHAT: "Purchase code (ISTHERA)",
  ISTHERA_CODE_BARRE: "Barcode",
  ISTHERA_COMMENTAIREA: "SKU",
  ISTHERA_DEPARTEMENT: "Department",
  ISTHERA_SEARCH: "Search (code, description, barcode…)",
  ISTHERA_ALL_DEPARTEMENTS: "All departments",
  ISTHERA_NO_RESULT: "No product matches the filter.",
  ISTHERA_ACTIVE: "Active at POS",
  ISTHERA_SYNC_STATUS: "Sync status",
  ISTHERA_LINKED: "Linked to ERP",
};
